// Wrapper page for the gear-menu "Terms & Conditions" entry.
// Renders TermsView in embedded mode (no modal close button) inside
// the standard page chrome.

import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import TermsView from "./TermsView";

export default function TermsPage() {
    const { h, t, go, role } = useContext(Ctx);
    return (
        <div style={{ paddingTop: 16 }}>
            <button
                onClick={() => go(role === "landlord" ? "settings" : "dash")}
                style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>
                &larr; {t.back || "Back"}
            </button>
            <TermsView embedded />
        </div>
    );
}
